module.exports = __webpack_public_path__ + "files/c8f5f2c5cef9605ead53994fbe3805a4.png";